module.exports = __webpack_public_path__ + "static/img/cus_04_pre.275f6a2e.jpg";